import { Fragment, ReactElement } from "react";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

type Option = {
  value: any;
  label: any;
  disabled?: boolean;
  style?: any;
  desc?: any;
}

interface Props {
  value: any;
  options: Option[];
  rowDirection?: boolean;
  disabled?: boolean;
  onChange: (value: any) => void;
}

export default function Radios({
  value,
  options,
  rowDirection = true,
  disabled = false,
  onChange,
}: Props): ReactElement {

  return (
    <RadioGroup
      aria-disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      row={rowDirection}
      aria-labelledby="demo-controlled-radio-buttons-group"
      name="controlled-radio-buttons-group"
    >
      {options.map((option: Option) => (
        <Fragment key={option.label}>
          <FormControlLabel
            value={option.value}
            control={<Radio disabled={option?.disabled ?? false} />}
            label={option.label}
            sx={option.style ?? {}}
          />
          {option.desc && option.desc}
        </Fragment>
      ))}
    </RadioGroup>
  );
}
